import { SharePointReportProfileShare } from '../../../microsoft/sharepoint/profile/share-point-report-profile-share';

export class SharePointReportProfileShares {
  webUrl: string;
  shares: SharePointReportProfileShare[];
}
